import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';
import { secondary300 } from 'themes/colors';

export default function Cross(props) {
  return (
    <SvgIcon {...props}>
      <path
        fill={secondary300}
        d="M7.70710678,6.29289322 L12,10.585 L16.2928932,6.29289322 C16.6834175,5.90236893
          17.3165825,5.90236893 17.7071068,6.29289322 C18.0976311,6.68341751 18.0976311,7.31658249
          17.7071068,7.70710678 L13.415,12 L17.7071068,16.2928932 C18.0976311,16.6834175 18.0976311,17.3165825
          17.7071068,17.7071068
          C17.3165825,18.0976311 16.6834175,18.0976311 16.2928932,17.7071068 L12,13.415 L7.70710678,17.7071068
          C7.31658249,18.0976311 6.68341751,18.0976311 6.29289322,17.7071068 C5.90236893,17.3165825
          5.90236893,16.6834175
          6.29289322,16.2928932 L10.585,12 L6.29289322,7.70710678 C5.90236893,7.31658249 5.90236893,6.68341751
          6.29289322,6.29289322 C6.68341751,5.90236893 7.31658249,5.90236893 7.70710678,6.29289322 Z"
      />
    </SvgIcon>
  );
}
